import compose from 'compose-function';
// import withRouter from './with-router';
import withStore from './with-store';

// const withProviders = compose(withStore, withRouter, withHelmet);
const withProviders = compose(withStore);

export default withProviders;
